import { UploadedFileResponseDtoStatusEnum } from 'libs/pinnacle-sdk';
import { cn } from 'utils';
interface StatusLoaderProps {
  status?: UploadedFileResponseDtoStatusEnum;
}

export default function StatusLoader({ status }: StatusLoaderProps) {
  const getStatusColor = (status?: UploadedFileResponseDtoStatusEnum) => {
    switch (status) {
      case UploadedFileResponseDtoStatusEnum.Validating:
        return 'bg-blue-500';
      case UploadedFileResponseDtoStatusEnum.Processing:
        return 'bg-yellow-500';
      case UploadedFileResponseDtoStatusEnum.Completed:
        return 'bg-green-500';
      case UploadedFileResponseDtoStatusEnum.Failed:
        return 'bg-red-500';
      default:
        return 'bg-gray-500';
    }
  };

  const isAnimated =
    status === UploadedFileResponseDtoStatusEnum.Validating ||
    status === UploadedFileResponseDtoStatusEnum.Processing;

  return (
    <div className="flex flex-col items-center">
      <div className="relative">
        <div
          className={cn(
            'w-10 h-10 rounded-full',
            getStatusColor(status),
            isAnimated && 'animate-pulse'
          )}
        />
        {isAnimated && (
          <div
            className={cn(
              'absolute top-0 left-0 w-10 h-10 rounded-full',
              getStatusColor(status),
              'animate-ping opacity-75'
            )}
          />
        )}
      </div>
      <span className="mt-2 text-sm font-medium">{status}</span>
    </div>
  );
}
